import { useAuthStore } from '@/stores/auth/useAuthStore'
import useRouter, { Route } from '@/composables/useRouter'
import { URLS } from '@/router/routes/urlRoutes'
import { checkIsMobile } from '@/helpers/navigator'

export default function useAuthRedirect() {
  const authStore = useAuthStore()
  const { goToRoute, goToLogin, goToMobile } = useRouter()

  function redirectByUser() {
    if (authStore.error) {
      goToLogin()
      return
    }

    if (authStore.isDFAUser) {
      window.location.href = authStore.DFAUrl
      return
    }

    if (authStore.isMultiCompany) {
      goToRoute({ name: URLS.SELECT_COMPANY })
      return
    }

    redirectByUserType()
  }

  function redirectByUserType() {
    if (authStore.error || !authStore.isUserLogged) {
      goToLogin()
      return
    }

    if (checkIsMobile() && authStore.isLexonUser) {
      goToMobile()
      return
    }

    if (authStore.isNextUrl) {
      goToRoute(authStore.nextUrl)
      authStore.setNextUrl({} as Route)
      return
    }

    if (authStore.isDMSUser) {
      goToRoute({ name: URLS.REPOSITORY })
      return
    }

    if (authStore.isLexonUser) {
      goToRoute({ name: URLS.DASHBOARD })
      return
    }

    if (authStore.isCustomerPortal) {
      return goToRoute({ name: URLS.EXPEDIENTS })
    }

    if (authStore.isFactureUser) {
      return goToRoute({ name: URLS.CUSTOMER_INVOICES })
    }
  }

  return {
    redirectByUser,
    redirectByUserType
  }
}

export type UseAuthRedirect = ReturnType<typeof useAuthRedirect>
